import Script from 'next/script';
import { useEffect, useRef, useState } from 'react';

declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement: (element: HTMLElement, force: boolean) => void;
    };
  }
}

export const TrustpilotCarouselWidget = () => {
  const widgetRef = useRef<HTMLDivElement>(null);
  const [isMobile, setIsMobile] = useState<boolean | null>(null);
  const [scriptReady, setScriptReady] = useState(false);

  // Detect mobile
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const update = () => setIsMobile(mq.matches);

    update();

    if (mq.addEventListener) {
      mq.addEventListener('change', update);
      return () => mq.removeEventListener('change', update);
    } else {
      mq.addListener(update);
      return () => mq.removeListener(update);
    }
  }, []);

  // Initialise Trustpilot once ready
  useEffect(() => {
    if (!scriptReady) return;
    if (isMobile === null) return;

    const el = widgetRef.current;
    if (!el) return;

    // Hard reset (important when switching templates)
    el.innerHTML = '';

    const templateId = isMobile
      ? '54ad5defc6454f065c28af8b'
      : '53aa8912dec7e10d38f59f36';

    const height = isMobile ? '250px' : '140px';

    const widget = document.createElement('div');
    widget.className = 'trustpilot-widget';
    widget.setAttribute('data-locale', 'en-GB');
    widget.setAttribute('data-template-id', templateId);
    widget.setAttribute('data-businessunit-id', '601882c742c1850001d9c876');
    widget.setAttribute('data-style-height', height);
    widget.setAttribute('data-style-width', '100%');
    widget.setAttribute('data-stars', '4,5');
    widget.setAttribute('data-review-languages', 'en');

    el.appendChild(widget);

    window.Trustpilot?.loadFromElement?.(widget, true);
  }, [scriptReady, isMobile]);

  return (
    <div style={{ width: '100%' }}>
      <Script
        id="trustpilot-script"
        src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        strategy="afterInteractive"
        onLoad={() => setScriptReady(true)}
      />

      <div ref={widgetRef} />
    </div>
  );
};
